<template>
  <technical-page-wrapper>
    <technical-section
      :title="t('serviceIsNotAvailableInYourRegion')"
      :description="t('serviceIsCurrentlyNotAvailableInYourRegion')"
      image="/img/technical_system.webp"
    >
    </technical-section>
  </technical-page-wrapper>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
import TechnicalSection from 'components/technical/TechnicalSection.vue'
import TechnicalPageWrapper from 'components/technical/TechnicalPageWrapper.vue'

const { t } = useI18n()
</script>

<style scoped lang="scss"></style>
